import { AxiosResponse } from 'axios';
import grispiApi from '../../apis/grispiApi';
import { BulkTicketChangeFormValues } from '../../components/Forms/BulkTicketChangeForm';
import { AdvancedSearchFormValues } from '../../components/SearchDrawer/AdvancedSearchDrawer';
import { AutomationJobProgress } from '../../containers/Pages/AdminPage/AutomationView/AutomationJobHistoryView/AutomationJobHistoryTableContainer';
import { JobStatusTypeMap } from '../../containers/Pages/AdminPage/FiltersView/ExportFiltersView/ExportFiltersTable';
import {
    CreateCallTicketReturnedData,
    CreateTicketPostData,
    CreateTicketReturnedData,
    EditTicketPostData,
    EditTicketReturnedData,
    NewTicket,
    Ticket
} from '../../model/types';
import { fetcherWithToken } from '../../utils/fetchers';

export const deleteTicket = async (ticketKey: string): Promise<AxiosResponse<any>['data']> => {
    const response = await grispiApi.delete(`/tickets/${ticketKey}`);
    return response.data;
};

//! no use case right now
export const getTickets = async (): Promise<Ticket[]> => {
    const initialTicketList = await fetcherWithToken('/tickets');

    return initialTicketList;
};

export const getTicketById = async (ticketId: string): Promise<NewTicket> => {
    const ticketDetail = await fetcherWithToken(`/tickets/${ticketId}?ui=true`);

    return ticketDetail;
};

//! no use case right now
export const getTicketChangesById = async (ticketId: string): Promise<Ticket> => {
    const interactions = await fetcherWithToken(`/changes/${ticketId}`);

    return interactions;
};

export const createTicket = async (createTicketPostData: CreateTicketPostData): Promise<CreateTicketReturnedData> => {
    const response = await grispiApi.post('/tickets', createTicketPostData);

    return response.data;
};

export const editTicket = async (editTicketPostData: EditTicketPostData): Promise<EditTicketReturnedData> => {
    const { id, ...postData } = editTicketPostData;

    const response = await grispiApi.patch(`/tickets/${id}?ui=true`, postData);

    return response.data;
};

export interface BulkTicketChangeJob {
    id: string;
    startedAt: number;
    finishedAt: number;
    type: 'BULK';
    status: JobStatusTypeMap;
    progress: AutomationJobProgress;
    userId: number; // user that started the bulk-ticket-change job
}
export const bulkTicketChange = async (bulkTicketChangePostData: BulkTicketChangeFormValues) => {
    const { ticketKeyList, ...postData } = bulkTicketChangePostData;

    const response = await grispiApi.post<BulkTicketChangeJob>(
        `/tickets/bulk-jobs?keys=${ticketKeyList.join(',')}`,
        postData
    );

    return response.data;
};

export interface CallTicketPostData {
    callId: string;
    direction: 'INBOUND' | 'OUTBOUND';
    destination: string;
    source: string;
    ticketKey?: string;
}
export const createCallTicket = async (
    createCallTicketPostData: CallTicketPostData
): Promise<CreateCallTicketReturnedData> => {
    const response = await grispiApi.post('/tickets/for-call', createCallTicketPostData);

    return response.data;
};

export const createCallComment = async (callData: CallTicketPostData): Promise<CreateCallTicketReturnedData> => {
    const response = await grispiApi.post(`/calls/click-to-call/${callData.ticketKey}`, callData);

    return response.data;
};

export interface MergeTicketPostData {
    sourceKey: string;
    targetKey: string;
    resolution: 'MERGED_BY_CALL' | 'MERGED_BY_WEB';
}

export const mergeTicket = async (mergeTicketPostData: MergeTicketPostData): Promise<any> => {
    const response = await grispiApi.post('/merge/ticket', mergeTicketPostData);

    return response.data;
};

export const cancelMerge = async (ticketKey: string): Promise<any> => {
    const response = await grispiApi.post(`/tickets/${ticketKey}/cancel-merge`);

    return response.data;
};

export const getAdvancedSearchedTickets = async (conditions: AdvancedSearchFormValues['conditions']) => {
    const response = await grispiApi.post('/tickets/advanced-search', {
        userAnyConditions: [],
        anyConditions: [],
        ...conditions
    });
    return response.data;
};
